import React, {Component} from 'react';
import {Link} from "react-router-dom";
import colors from "../../utils/colors";
import LoadingPage from "../../components/LoadingPage";
import apiMyAccount from "../../api/MyAccount";

class MenuCard extends React.Component {
    render() {
        return (
            <Link to={this.props.link}>
                <div className="menu-card link-eunset cursor-pointer">
                    <div className="menu-card__img py-1">
                        <img
                            src={this.props.img}
                            className="p-2"
                            style={{ width: "100%" }}
                            alt="icon"
                        />
                    </div>
                    <div className="menu-card__content py-1">
                        <div
                            style={{ color: this.props.color, fontSize: "1.2rem" }}
                            className="font-weight-bold"
                        >
                            {this.props.title}
                        </div>
                        {this.props.description ? (
                            <div className="text-muted mt-1">{this.props.description}</div>
                        ) : null}
                    </div>
                    <div
                        className="menu-card__caret"
                        style={{ backgroundColor: this.props.color }}
                    >
                        {">"}
                    </div>
                </div>
            </Link>
        );
    }
}

class Guides extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
        };
    }

    async componentDidMount() {
        try {
            const json = await apiMyAccount.getArticle();
            if (json.data.code === 0) {
                this.setState({ data: json.data.data, loading: false });
            } else {
                this.setState({ loading: false });
            }
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    render() {
        if (this.state.loading) {
            return <LoadingPage />;
        }

        return (
            <div className='home-page' style={{ overflow: 'scroll' }}>
                {this.state.data.map((item) => (
                    <MenuCard
                        key={item.id}
                        title={item.title}
                        description={item.description !== '.' ? item.description : ''}
                        img={item.img}
                        color={colors.facebookColor}
                        link={`/huong-dan/${item.id}`}
                    />
                ))}
            </div>
        );
    }
}

export default Guides;
